<script>
	export default {
		name: 'RecruitExecuter',
		methods: {
			getRecruitmentByRecruitmentId(recruitmentId) {
				const self_ = this;

				let recruitment_ = {}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreDocument('recruitments', recruitmentId)
					}).then(result => {
						if(!self_.isEmpty(result)) { 
							recruitment_[recruitmentId] = result; 
						} else {
							recruitment_.dummy = self_.getRecruitmentsState('dummy');
						}
						return
					}).then(() => {
						if(self_.isEmpty(recruitment_[recruitmentId])) { resolve(recruitment_) }
						return self_.getFirestoreSubCollection('recruitments', recruitmentId, 'schedules')
					}).then(result => {
						if(!self_.isEmpty(result)) { 
							recruitment_[recruitmentId].schedules = result;
						}
						resolve(recruitment_)
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: getRecruitmentByRecruitmentId(' + recruitmentId + ') -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			getRecruitmentByRecruitmentIdAndScheduleId(recruitmentId, scheduleId) {
				const self_ = this;

				let schedule_ = {}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreSubCollection('recruitments', recruitmentId, 'schedules')
					}).then(result => {
						if(!self_.isEmpty(result)) { 
							schedule_ = result;
						} else {
							const dummy_ = self_.getRecruitmentsState('dummy')

							Object.keys(dummy_.schedules).forEach(key => {
								schedule_[key] = dummy_.schedules[key]
							})
						}
						return
					}).then(() => {
						if(self_.isEmpty(schedule_[scheduleId])) { resolve(schedule_) }
						return self_.getFirestoreSubSubCollection('recruitments', recruitmentId, 'schedules', scheduleId, 'sections')
					}).then(result => {
						if(!self_.isEmpty(result)) { 
							schedule_[scheduleId].sections = result;
						}
						resolve(schedule_)
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: getRecruitmentByRecruitmentIdAndScheduleId(' + recruitmentId + ',' + scheduleId + ') -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			}
		}
	}
</script>